import EntityBase from '@/data/EntityBase';
import type Request from './model';

export default class RequestState extends EntityBase<Request, { updating: number }>({
  updating: 0,
}) {
  // Nothing
}
